import { render } from "./criteria-questions.vue?vue&type=template&id=5037c253&scoped=true&ts=true"
import script from "./criteria-questions.vue?vue&type=script&lang=ts"
export * from "./criteria-questions.vue?vue&type=script&lang=ts"

import "./criteria-questions.vue?vue&type=style&index=0&id=5037c253&lang=scss&scoped=true"
import "./criteria-questions.vue?vue&type=style&index=1&id=5037c253&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5037c253"]])

export default __exports__